export default {
  // Navigation
  'nav.home': 'หน้าแรก',
  'nav.product': 'ผลิตภัณฑ์',
  'nav.cases': 'กรณีศึกษา',
  'nav.findDoctor': 'คู่มือผู้ปกครอง',
  'nav.about': 'เกี่ยวกับเรา',
  'nav.doctorLogin': 'เข้าสู่ระบบแพทย์',
  
  // Common
  'common.learnMore': 'เรียนรู้เพิ่มเติม',
  'common.contactUs': 'ติดต่อเรา',
  'common.submit': 'ส่ง',
  'common.search': 'ค้นหา',
  
  // Footer
  'footer.quickLinks': 'ลิงก์ด่วน',
  'footer.contact': 'ติดต่อเรา',
  'footer.followUs': 'ติดตามเรา',
  'footer.copyright': '© 2024 Mirókids. สงวนลิขสิทธิ์.',
  'footer.phone': 'โทรศัพท์',
  'footer.email': 'อีเมล',
  'footer.address': 'ที่อยู่',
};
